import React from "react";
import EntitySelector from "./index";
import { usePress } from "../../context/PressContext";

const PressSelector = () => {

  const {selectedPress, loading, setSelectedPress, pressOptions} = usePress();

  return (
    <EntitySelector
      entities={pressOptions}
      selectedEntityId={selectedPress}
      onEntityChange={setSelectedPress}
      loading={loading}
      placeholder="All Sources"
      label="Sources"
      icon="newspaper"
      loadingText="Loading press options..."
      emptyResultText="No press options found"
    />
  );
};

export default PressSelector;